import PropTypes from 'prop-types';
import React from 'react';
import { BookingSummaryUpdatedItem } from './BookingSummaryUpdatedItem';

export const BookingSummaryItem = ({
  label,
  children,
  updatedContent,
  testingId
}) => {
  return (
    <div data-testing-id={testingId}>
      <label data-testing-id={`${testingId}-label`}>{label}</label>
      <div className='text-gray-dark' data-testing-id={`${testingId}-value`}>
        {!updatedContent ? (
          children
        ) : (
          <BookingSummaryUpdatedItem
            currentContent={children}
            testingId={`${testingId}-updated`}
            newContent={updatedContent}
          />
        )}
      </div>
    </div>
  );
};

BookingSummaryItem.propTypes = {
  children: PropTypes.oneOfType([PropTypes.element, PropTypes.string])
    .isRequired,
  label: PropTypes.oneOfType([PropTypes.element, PropTypes.string]).isRequired,
  updatedContent: PropTypes.oneOfType([
    PropTypes.element,
    PropTypes.string,
    PropTypes.bool
  ]),
  testingId: PropTypes.string
};
